// the values should match the name of the fees from the backend
export const FEE_TYPES = {
  'gdmth': 'GDMTH'
}
